import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=5134a8e6&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=ts"
export * from "./OrderForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=5134a8e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5134a8e6",
  null
  
)

export default component.exports